// extracted by mini-css-extract-plugin
export default {"title":"style_title__Lu8cA","list":"style_list__ydBQm","list_item":"style_list_item__LENYZ"};